import React, { useEffect, useState, useTransition } from "react";
import Heading from "../components/common/Heading";
import CommonHeading from "../components/common/CommonHeading";
import { contact } from "../components/data/Data";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader } from "../components/common/loader";

export default function Contact() {
  const [states, setStates] = useState([]); // Stores the list of states
  const [cities, setCities] = useState([]); // Stores the list of cities for the selected state
  const [selectedState, setSelectedState] = useState(""); // Stores the selected state
  const [differenceInDays, setDifferenceInDays] = useState(0);
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [emailData, setEmailData] = useState({});
  const [subject, setSubject] = useState("");
  const [isPending, startTransition] = useTransition(); //uses to load data

  const location = useLocation();
  const contactPath = location.pathname.includes("/contact");
  const navigate = useNavigate(); // Initialize useNavigate for redirection

  // Get today's date in YYYY-MM-DD format
  const currentUrl = window.location;
  // const bookingPath = currentUrl.pathname.includes("booking");
  const today = new Date().toISOString().split("T")[0];

  // Function to calculate the difference in days
  const calculateDateDifference = (checkIn, checkOut) => {
    if (checkIn && checkOut) {
      const checkInDateObj = new Date(checkIn);
      const checkOutDateObj = new Date(checkOut);

      // Difference in milliseconds
      const differenceInMs = checkOutDateObj - checkInDateObj;

      // Convert milliseconds to days
      const daysDifference = differenceInMs / (1000 * 60 * 60 * 24);

      setDifferenceInDays(daysDifference);
    }
  };

  const hasAccents = (text) => /[\u0300-\u036f\u00C0-\u00FF]/.test(text);

  // Get all states
  useEffect(() => {
    fetch("https://countriesnow.space/api/v0.1/countries/states", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country: "India" }),
    })
      .then((response) => response.json())
      .then((json) => {
        const stateData = json.data.states.map((state) => state.name);
        setStates(stateData);
      })
      .catch((error) => {
        console.error("Error fetching states:", error);
      });
  }, []);

  // Get all cities based on state
  useEffect(() => {
    if (!selectedState) return;
    fetch("https://countriesnow.space/api/v0.1/countries/state/cities", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country: "India", state: selectedState }),
    })
      .then((response) => response.json())
      .then((json) => {
        const filteredCities = json.data.filter((city) => !hasAccents(city));
        setCities(filteredCities);
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
      });
  }, [selectedState]);

  // State change function
  const handleStateChange = (event) => {
    setSelectedState(event.target.value);
    setCities([]);
  };

  // Function to handle email submission
  const sendMailInquiry = async (event) => {
    event.preventDefault(); // Prevent form from reloading the page

    const emailDetails = {
      consumerName: event.target.consumerName.value,
      consumerLast: event.target.consumerLast.value,
      email: event.target.consumerEmail.value,
      contactNumber: event.target.contactNumber.value,
      state: event.target.state.value,
      city: event.target.city.value,
      roomType: event.target.roomType.value,
      chekindate: event.target.chekindate.value,
      chackoutdate: event.target.chackoutdate.value,
      adults: event.target.adults.value,
      child: event.target.child.value,
    };

    const subjectLine = "Contact & Inquiry";
    // Use `startTransition` to handle the loading state
    startTransition(async () => {
      setSubject(subjectLine);
      setEmailData(emailDetails); // Correctly set state

      try {
        const response = await axios.post(
          "https://api.bgmhotel.com/send-email",
          {
            emailDetails,
            subject: subjectLine,
          }
        );

        console.log(response.data.message);

        // Navigate to the thank you page on successful submission
        navigate("/contact/thankyou");
      } catch (error) {
        console.error("Error sending email:", error);
      }
    });
  };
  return (
    <>
      {contactPath ? (
        <Heading heading="Contact Us" title="Home" subtitle="Contact" />
      ) : (
        ""
      )}

      <div className="container py-5">
        <div className="py-4">
          <h3>We'd Love to Hear from You!</h3>
          <p className="py-2">
            At BGM Hotel & Restaurant, your comfort and satisfaction are our top
            priorities. Whether you have a question, want to book a stay, or
            reserve a table, we're here to make the process as seamless as
            possible.
          </p>
          <h6>
            Please fill the bellow form and sed us your requirement or you can
            contact us with other methods:
          </h6>
          <div className="methods py-2 px-2">
            <p>
              📞 <span className="fw-bold">Call Us -</span> Our friendly team is
              just a call away to assist with your inquiries or bookings.
            </p>
            <p>
              📧 <span className="fw-bold">Email Us -</span> Prefer writing?
              Drop us a message, and we'll get back to you promptly.
            </p>
            <p>
              📍 <span className="fw-bold">Visit Us -</span> Come by and
              experience the charm of BGM Hotel & Restaurant in person.
            </p>
          </div>
        </div>

        <div className="">
          <CommonHeading
            heading="Contact Us"
            subtitle="Contact "
            // title="For Booking & Enquiry"
            title={contactPath ? "For Enquiry" : "For Booking"}
          />

          <div className="row g-4">
            <div className="col-12">
              <div className="row gy-4">
                {contact.map((item, index) => (
                  <div className="col-md-6 text-center" key={index}>
                    <h6 className="text-warning text-uppercase">
                      {item.title}
                    </h6>
                    <p>
                      {item.icon}
                      {item.email}
                    </p>
                  </div>
                ))}
              </div>
              <hr style={{ color: "#FEA116", opacity: "1" }} />
              {/* <hr style={{ border: "#FEA116", opacity: "1" }} /> */}
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="wow fadeInUp" data-wow-delay="0.2s">
                <form className="row g-3" onSubmit={sendMailInquiry}>
                  <div className="col-md-6">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      required
                      name="consumerName"
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter Your Name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="lastname" className="form-label">
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="consumerLast"
                      className="form-control"
                      id="lastname"
                      placeholder="Enter Your Last Name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="lastname" className="form-label">
                      Email
                    </label>
                    <input
                      required
                      type="email"
                      name="consumerEmail"
                      className="form-control"
                      id="lastname"
                      placeholder="Enter Your Last Name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="Contact Number" className="form-label">
                      Contact Number
                    </label>
                    <input
                      required
                      type="text"
                      name="contactNumber"
                      className="form-control"
                      placeholder="Contact Number"
                      aria-label="Contact Number"
                      aria-describedby="btnGroupAddon2"
                      maxLength="10"
                      pattern="\d{10}"
                      onInput={(e) =>
                        (e.target.value = e.target.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 10))
                      }
                    />
                  </div>

                  {/* <div className="col-md-6">
              <label htmlFor="inputState" className="form-label">
                State
              </label>
              <select
                name="state"
                value={selectedState}
                onChange={handleStateChange}
                className="form-select"
              >
                <option>Select a state</option>
                {states.map((state, index) => (
                  <option key={index} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label htmlFor="inputState" className="form-label">
                City
              </label>
              <input
                name="city"
                type="text"
                className="form-control"
                id="inputZip"
                placeholder="Enter City"
              />
            </div> */}

                  <div className="col-md-6">
                    <label htmlFor="state" className="form-label">
                      State
                    </label>
                    <select
                      name="state"
                      id="state"
                      className="form-control"
                      required
                      value={selectedState}
                      onChange={handleStateChange}
                    >
                      <option value="">Select State</option>
                      {states.map((state, index) => (
                        <option key={index} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="city" className="form-label">
                      City
                    </label>
                    <select
                      id="city"
                      className="form-control"
                      required
                      name="city"
                    >
                      <option value="">Select City</option>
                      {cities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="inputState" className="form-label">
                      Select Room Type
                    </label>
                    <select
                      id="inputState"
                      className="form-select"
                      name="roomType"
                      required
                    >
                      <option defaultValue value="">
                        Select Room Type
                      </option>
                      <option value="Normal Room">Normal Room</option>
                      <option value="Standard Room">Standard Room</option>
                      <option value="Luxury Room">Luxury Room</option>
                      <option value="Delux Room">Delux Room</option>
                      <option value="Super Delux Room">Super Delux Room</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="chekin" className="form-label">
                      Check In
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="chekindate"
                      name="chekindate"
                      required
                      min={new Date().toISOString().split("T")[0]} // Disable past dates
                      value={checkInDate}
                      onChange={(e) => {
                        setCheckInDate(e.target.value);
                        calculateDateDifference(e.target.value, checkOutDate);
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="checkout" className="form-label">
                      Check Out
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="checkout"
                      name="chackoutdate"
                      required
                      min={
                        checkInDate || new Date().toISOString().split("T")[0]
                      } // Disable dates before check-in
                      value={checkOutDate}
                      onChange={(e) => {
                        setCheckOutDate(e.target.value);
                        calculateDateDifference(checkInDate, e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="checkout" className="form-label">
                      Number of Person Adult
                    </label>
                    {/* <div className="col-md-6"> */}
                    <div className="input-group col-md-6">
                      <div className="input-group-text" id="btnGroupAddon2">
                        Adult
                      </div>
                      <input
                        required
                        type="text"
                        name="adults"
                        className="form-control"
                        placeholder="Number of Adults"
                        aria-describedby="btnGroupAddon2"
                        maxLength="2"
                        onInput={(e) =>
                          (e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 6))
                        }
                      />
                    </div>
                    {/* </div> */}
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="inputZip" className="form-label">
                      Number of Person Child
                    </label>
                    <div className="input-group">
                      <div className="input-group-text" id="btnGroupAddon2">
                        Child
                      </div>
                      <input
                        name="child"
                        type="text"
                        className="form-control"
                        placeholder="Number of Child"
                        aria-describedby="btnGroupAddon2"
                        maxLength="2"
                        onInput={(e) =>
                          (e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 6))
                        }
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-sm-12 col-xs-12">
                    <button
                      disabled={isPending} // Disable button during loading
                      type="submit"
                      className="btn btn-primary-custom col-lg-6 col-md-12 col-sm-12 col-xs-12"
                    >
                      {isPending ? "please wait.." : "SUBMIT"}
                      {/* Button text changes dynamically */}
                      {isPending && <Loader />}
                      {/* Show loader when isPending is true */}
                    </button>
                  </div>
                </form>
                {/* <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Your Name"
                        />
                        <label for="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Your Email"
                        />
                        <label for="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          placeholder="Subject"
                        />
                        <label for="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Leave a message here"
                          id="message"
                          style={{ height: "150px" }}
                        ></textarea>
                        <label for="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary-custom w-100 py-3"
                        type="submit"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form> */}
              </div>
            </div>
            <div
              className="col-lg-6 col-md-12 wow fadeIn"
              data-wow-delay="0.1s"
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14083.479582532531!2d76.421748!3d28.0589969!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3912ab0071a8b78b%3A0x627fd593795237bf!2sBGM%20Hotel!5e0!3m2!1sen!2sin!4v1730086049452!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-aos="zoom-in-down"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
